import { Tag as _Tag } from 'antd';
import styled, { css } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const Tag = styled(_Tag)`
  // Without this the global dark-mode span color repaints the icon alone.
  .anticon {
    color: inherit;
  }

  // Colored tags keep antd's fill, text and border; this rule would otherwise override preset colors.
  ${({ theme, color }) =>
    theme.themeName === Theme.Dark && !color
      ? css`
          background: ${theme.activeMenuItemBackgroundColor};
          border-color: ${theme.tertiaryBackgroundColor};
          color: ${theme.secondaryTextColor};
        `
      : ''}
`;
